export const visit = (vm, at) => {
at({ "ja": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}}/{{totalBytes}}" }, "fileSizeLimit": "\u30D5\u30A1\u30A4\u30EB\u306E\u30B5\u30A4\u30BA\u306F{{size}}\u307E\u3067\u3067\u3059" } } });
};